import { array, struct } from 'io-ts/Decoder';

import { Id as MaterialId } from '../../../../whole-house/material/Id';
export const Request = struct({
	materialIds: array(MaterialId),
});
